const Loader = ({ style }) => {
  return (
    <div className="flex items-center justify-center">
      <div className={style} />
    </div>
  );
};

export default Loader;
